module.exports = __webpack_public_path__ + "static/media/music_bg.6a58d58.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/music_bg.mp3
// module id = 139
// module chunks = 1